import React, {useEffect, useState} from "react";
import "./styles.css";
import Lottie from "react-lottie";
import logoAnimation from "../../../assets/animations/welcome.json";
import arrowAnimation from "../../../assets/animations/arrow.json";
import environment from "../../../environment";
import * as QRcode from "qrcode";
import {Button} from "antd";
import {GlobalOutlined} from "@ant-design/icons";
import {useLocation} from "react-router-dom";

export default function RedirectToMobile() {
  const path = useLocation();

  const [imageSrc, setImageSrc] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [animationSpeed, setAnimationSpeed] = useState(0);

  const logoAnimationRef = React.useRef();

  useEffect(() => {
    // Check if user is on a mobile device
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)) {
      setIsMobile(true);
    }

    generateQRcode();
  }, []);

  useEffect(() => {
    setAnimationSpeed(1);
    setTimeout(() => {
      setAnimationSpeed(0);
    }, 900);
  }, [logoAnimationRef.current]);

  const link =
    // eslint-disable-next-line max-len
    "https://app.adjust.com/1gxrjgxx?deep_link=at.taxefy.app%3A%2F%2Fregister%3Ftaxefy_campaign%3Dtrue%26partner%3DINSERT_PARTNER_NAME&fallback=https%3A%2F%2Fapp.taxefy.at%2Fauth%2Fregister%3Ftaxefy_campaign%3Dtrue%26partner%3DINSERT_PARTNER_NAME&redirect_macos=https%3A%2F%2Fapp.taxefy.at%2Fauth%2Fregister%3Ftaxefy_campaign%3Dtrue%26partner%3DINSERT_PARTNER_NAME&label=INSERT_PARTNER_NAME";

  const noPartnerLink = // eslint-disable-next-line max-len
    "https://app.adjust.com/1gxrjgxx?deep_link=at.taxefy.app%3A%2F%2Fregister%3Ftaxefy_campaign%3Dfalse&fallback=https%3A%2F%2Fapp.taxefy.at%2Fauth%2Fregister%3Ftaxefy_campaign%3Dfalse&redirect_macos=https%3A%2F%2Fapp.taxefy.at%2Fauth%2Fregister%3Ftaxefy_campaign%3Dfalse";

  const generateQRcode = async () => {
    const alteredlink = figureOutLink();
    const code = await QRcode.toDataURL(alteredlink, {
      color: {
        dark: "#00BEAA"
      },
      errorCorrectionLevel: "H"
    });
    setImageSrc(code.toString("svg"));
  };

  const figureOutLink = () => {
	  let partnerPath = path.search.split("link=")[1];
    if(!partnerPath) path.search.split("partner=")[1];

	  const temp = link.replaceAll("INSERT_PARTNER_NAME", partnerPath);
    return partnerPath ? temp : noPartnerLink;
  };

  return (
    <>
      {isMobile ? (
        <div className={"mobile-container"}>
          <div className={"top-container"}>
            <div>
              <Lottie
                ref={logoAnimationRef}
                options={{
                  loop: false,
                  autoplay: false,
                  animationData: logoAnimation
                }}
                isClickToPauseDisabled={true}
                style={{
                  width: "13vh",
                  height: "13vh"
                }}
                speed={animationSpeed}
              />
              <h1 className={"title"}>
                Dein Konto <br /> wurde aktiviert!
              </h1>
            </div>
          </div>
          <div className={"bottom-container"}>
            {/*<p
							className={"link"}
							onClick={handleAppOpen}
						>
							App öffnen
						</p>*/}
            <Lottie
              options={{
                loop: false,
                autoplay: true,
                animationData: arrowAnimation
              }}
              className={"arrow-animation"}
              style={{
                transform: "rotate(75deg)",
                width: "50px",
                height: "100px",
                position: "absolute",
                top: "0px",
                left: "72%"
              }}
            />
            <div>
              <h2 className={"bottom-text green"}>Einfach weiter</h2>
              <h3 style={{marginTop: "-26px"}} className={"bottom-text"}>
                zur App
              </h3>
            </div>
          </div>
        </div>
      ) : (
        <div style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
          <div style={{padding: "15px"}}>
            <h1 style={{fontSize: "40px", color: "rgba(0, 190, 170, 1)"}}>Mit deinem Handy weiter</h1>
            <p>Scanne den QR-Code mit deinem Handy um sofort mit Taxefy loszustarten</p>
          </div>
          <img
            style={{
              margin: "30px",
              border: "solid 12px rgba(0, 190, 170, 1)",
              borderRadius: "20px"
            }}
            src={imageSrc}
          />
          <Button
            onClick={() => window.open(figureOutLink(), "_blank")}
            icon={<GlobalOutlined />}
            style={{
              margin: "30px",
              fontSize: "20px",
              height: "10%",
              borderRadius: "20px",
              color: "rgba(0, 190, 170, 1)"
            }}
          >
            {"Zur Webseite"}
          </Button>
        </div>
      )}
    </>
  );
}

/*import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import * as QRcode from "qrcode";
import {Button} from "antd";
import {GlobalOutlined} from "@ant-design/icons";

export default function RedirectToMobile(props) {
	const path = useLocation();
	const [imageSrc, setImageSrc] = useState("");

	useEffect(() => {
		console.log(path);
		generateQRcode();
	}, []);

	const link =
		// eslint-disable-next-line max-len
		"https://app.adjust.com/1gxrjgxx?deep_link=at.taxefy.ap
		p%3A%2F%2Fregister%3Ftaxefy_campaign%3Dtrue%26partner%3DINSERT_PARTNER_NAME&fallback
		=https%3A%2F%2Fapp.taxefy.at%2Fauth%2Fregister%3Ftaxefy_campaign%3Dtrue%26partner%3DINSERT_PARTNER_NAME&redirect_macos=https%3A%2F%2Fapp.taxefy.at%2Fauth%2Fregister%3Ftaxefy_campaign%3Dtrue%26partner%3DINSERT_PARTNER_NAME";

	const noPartnerLink = // eslint-disable-next-line max-len
		"https://app.adjust.com/1gxrjgxx?deep_link=at.taxefy.app%3A%2F%2Fregister
		%3Ftaxefy_campaign%3Dfalse&fallback=https%3A%2F%2Fapp.taxefy.at%2Fauth%2Fregister%3Ftaxefy_campaign%3Dfalse&redirect_macos=https%3A%2F%2Fapp.taxefy.at%2Fauth%2Fregister%3Ftaxefy_campaign%3Dfalse";

	const generateQRcode = async () => {
		const alteredlink = path.search ? link.replaceAll("INSERT_PARTNER_NAME", path.search.split("partner=")[1]) : noPartnerLink;
		const code = await QRcode.toDataURL(alteredlink, {
			color: {
				dark: "#00BEAA"
			},
			errorCorrectionLevel: "H"
		});
		setImageSrc(code.toString("svg"));
	};


	return (

	);
}*/
